export const UsaaValidationLabels = {
    requesterType: { english: 'Requester type', spanish: 'Tipo de solicitante' },
    employeeId: { english: 'Employee ID', spanish: 'ID de empleado' },
    birthMonth: { english: 'Birth month', spanish: 'Mes de nacimiento' },
    birthDay: { english: 'Birth day', spanish: 'Día de nacimiento' },
    normalStartTime: { english: 'Normal Start Time', spanish: 'Hora de Inicio Normal' },
    estimatedArrival: { english: 'Estimated Arrival', spanish: 'Llegada Estimada' },
    departureTime: { english: 'Departure Time', spanish: 'Hora de Salida' },
    regularEndTime: { english: 'Regular End Time', spanish: 'Hora de Finalización Regular' },
    estimatedReturn: { english: 'Estimated Return', spanish: 'Regreso estimado' },
    durationHours: { english: 'Duration hours', spanish: 'Horas de duración' },
    durationMinutes: { english: 'Duration minutes', spanish: 'Minutos de duración' },
    startTimeHours: { english: 'Start time hours', spanish: 'Horas de inicio' },
    startTimeMinutes: { english: 'Start time minutes', spanish: 'Minutos de inicio' },
    endTimeHours: { english: 'End time hours', spanish: 'Horas de finalización' },
    endTimeMinutes: { english: 'End time minutes', spanish: 'Minutos de finalización' },
    normalStartHours: { english: 'Normal start hours', spanish: 'Horas de inicio normal' },
    normalStartMinutes: { english: 'Normal start minutes', spanish: 'Minutos de inicio normal' },
    estimatedArrivalHours: { english: 'Estimated arrival hours', spanish: 'Horas de llegada estimada' },
    estimatedArrivalMinutes: { english: 'Estimated arrival minutes', spanish: 'Minutos de llegada estimada' },
    departureTimeHours: { english: 'Departure time hours', spanish: 'Horas de salida' },
    departureTimeMinutes: { english: 'Departure time minutes', spanish: 'Minutos de salida' },
    regularEndHours: { english: 'Regular end hours', spanish: 'Horas de finalización regular' },
    regularEndMinutes: { english: 'Regular end minutes', spanish: 'Minutos de finalización regular' },
    estimatedReturnHours: { english: 'Estimated return hours', spanish: 'Horas de regreso estimado' },
    estimatedReturnMinutes: { english: 'Estimated return minutes', spanish: 'Minutos de regreso estimado' },
    typeOfTimeOff: { english: 'Type of time off', spanish: 'Tipo de tiempo libre' },
    reasonForTimeOff: { english: 'Reason for time off', spanish: 'Motivo del tiempo libre' },
};
